module.exports = __webpack_public_path__ + "static/img/integration.4184d987.png";